import {showToast} from "../../components/general/CustomToast";
import {TIME_LOGOUT} from "../../conf";
import {enqueueSnackbar} from "notistack";
import {clearCookiesAndCache} from "../../utils/decode/getSessionByCookie";
// import {getTokenRegistration} from "../session/apiSession";

export const NOT_ACCESS = 'Usuario no autorizado para acceso a esta función.'

export const getMessage = (status: number) => {
    switch (status) {
        case 504:
            return 'No se pudo obtener una respuesta.';
        case 500:
            return 'Ha ocurrido un error interno, comuníquese con el administrador.';
        case 401:
            return 'Las credenciales de acceso, usuario o contraseña son incorrectos.';
        case 403:
            return NOT_ACCESS;
        case 404:
            return 'No existen registros que mostrar.';
        default:
            return undefined;
    }
};

// function refreshSession(msj: boolean) {
//     getTokenRegistration().then(resp => {
//         if (resp && msj) {
//             enqueueSnackbar(`Realice nuevamente la acción, se restauró la autorización en el sistema.`, {variant: 'warning'});
//         }
//     });
// }

export function errorHandlerServices(
    error: any,
    redirect: boolean,
    service?: string,
    refreshTokenRegistration?: boolean,
    msj?: string,
    hiddenAlert?: boolean
) {
    if (error.response) {
        if (error?.response?.status === 401) {
            clearCookiesAndCache();
            if (refreshTokenRegistration) {
                // refreshSession(true)
            }
            if (redirect) {
                showToast(
                    'Sesión caducada',
                    'error'
                );
                // refreshSession(false)
                setTimeout(() => {
                    window.location.reload();
                }, TIME_LOGOUT);
            }
        }
        let msgError = getMessage(error.response.status);
        if (error?.response?.status !== 401 && error.response.data && error.response.data.message) {
            msgError =
                msgError && error.response.data.status === undefined ?
                    msgError :
                    error.response.data.message;
            if (!hiddenAlert) {
                enqueueSnackbar(
                    <div className={'flex flex-col max-w-[300px] justify-center items-center'}>
                        <div>
                            {msgError}
                        </div>
                        <div className={'font-light text-[11px]'}>
                            {`${msj ? msj : ''} ("${service ? service : ''}")`}
                        </div>
                    </div>
                    , {variant: 'warning'});
            }
        } else if (msgError) {
            if (!hiddenAlert) {
                enqueueSnackbar(
                    <div className={'flex flex-col max-w-[300px] justify-center items-center'}>
                        <div>
                            {msgError}
                        </div>
                        <div className={'font-light text-[11px]'}>
                            {`${msj ? msj : ''} ("${service ? service : ''}")`}
                        </div>
                    </div>
                    , {variant: 'warning'});
            }
        } else {
            if (!hiddenAlert) {
                enqueueSnackbar(
                    <div className={'flex flex-col max-w-[300px] justify-center items-center'}>
                        <div>
                            {error?.response?.data?.error_description}
                        </div>
                        <div className={'font-light text-[11px]'}>
                            {`${msj ? msj : ''} ("${service ? service : ''}")`}
                        </div>
                    </div>
                    , {variant: 'warning'});
            }
        }
    } else {
        if (!hiddenAlert) {
            enqueueSnackbar(
                <div className={'flex flex-col max-w-[300px] justify-center items-center'}>
                    <div>
                        {error?.toString()}
                    </div>
                    <div className={'font-light text-[11px]'}>
                        {`${msj ? msj : ''} ("${service ? service : ''}")`}
                    </div>
                </div>
                , {variant: 'warning'});
        }
    }
}

export const getMessageGeneric = (error: any | null | undefined, reference?: string | null) => {
    if (error === undefined || error === null) {
        return undefined
    }
    const msj = getMessage(error?.cause?.response?.status)
    const msjService = error?.cause?.response?.data?.message ? error?.cause?.response?.data?.message : error.toString();
    if (error?.cause?.response?.status === 403) {
        return `${NOT_ACCESS} ${reference ? reference : ''}`;
    }
    if (msj !== undefined) {
        return msj
    } else {
        return msjService
    }
};

export function getError(error: any, message: string) {
    const errorOption: ErrorOptions = {
        cause: error
    }
    throw new Error(
        message,
        errorOption
    );
}
